// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3vuUL","modalForm":"UpgradeEpcsModal_modalForm__14AJQ","modalFooter":"UpgradeEpcsModal_modalFooter__G9R9E"};